import React from 'react';
import ReactDOM from 'react-dom';
import './reset.scss';
import BuilderApp from 'components/builder/BuilderApp';

import Store from 'store';

import { loadAllItems } from 'data/load';
import Session from 'store/session';

import { Api } from 'api';
import EditingContext from 'store/editingContext';
import { stateFix } from 'logic/stateReducers';
import { getStoredValue } from 'common';

(async function() {
  const dataLoaded = loadAllItems(getStoredValue('lap-language', 'en'));

  let loading = null;
  const match = window.location.pathname.match(/\/la-builder\/(\w{8,9})$/);
  if (match) {
    const setName = window.location.hash && decodeURIComponent(window.location.hash.substring(1));
    loading = (new Api().load(match[1])).then(
      async result => {
        await dataLoaded;
        result = stateFix(result, match[1], result.user);
        if (setName) {
          if (!isNaN(setName)) {
            const id = parseInt(setName);
            const index = result.embeds.findIndex(e => e.id === id);
            if (index >= 0) {
              result.activeEmbed = index;
            }
          } else {
            const index = result.embeds.findIndex(embed => embed.name === setName);
            if (index >= 0) {
              result.activeEmbed = index;
            }
          }
        }
        await Store.instance.setState(result);
      },
      error => error.message,
    );
  } else {
    const stored = getStoredValue('lap-stateBackup', null, true);
    if (stored) {
      dataLoaded.then(() => {
        const state = {...Store.instance.getState(), builder: stored};
        return Store.instance.setState(stateFix(state));
      });
    }
  }

  await dataLoaded;

  const editingContext = new EditingContext();

  const session = new Session();
  const api = new Api(session.store);
  api.updateLogin();

  ReactDOM.render(
    <BuilderApp session={session} loading={loading} editingContext={editingContext}/>,
    document.querySelector('.laplanner-wrapper')
  );
})();
